<script>
  export let href = undefined;
  export let outline = false;
  export let style = "";
  export let target = "_blank";
</script>

<style>
  .button {
    -webkit-appearance: none;
    background-color: #ed1c24;
    color: white;
    border: 0;
    font-size: 1.25rem;
    font-weight: bold;
    border-radius: 0.625rem;
    padding: 1rem 1.5rem;
    box-sizing: border-box;
    text-decoration: none;
    user-select: none;
    display: inline-block;
  }

  .button.outline {
    background-color: transparent;
    color: #ed1c24;
    border: 2px solid #ed1c24;
    padding: 0.875rem 1.5rem;
  }

  @media screen and (min-width: 640px) {
    .button {
      padding: 1.4375rem 2rem;
    }

    .button.outline {
      padding: 1.295rem 2rem;
    }
  }
</style>

{#if href}
  <a class="button" class:outline {target} {href} {style}>
    <slot />
  </a>
{:else}
  <button on:click|preventDefault class="button" class:outline {href} {style}>
    <slot />
  </button>
{/if}
